import script from "./Verification.vue?vue&type=script&setup=true&lang=js"
export * from "./Verification.vue?vue&type=script&setup=true&lang=js"

import "./Verification.vue?vue&type=style&index=0&id=2a74b623&lang=css"

const __exports__ = script;

export default __exports__